import { Property, PropertyFormValues, updateLocation, updatePrimaryPhoto, updatePropertyFromFormValues } from "./propertyModel"

export type Action =
| { type: 'propertyLoaded', property: Property }
| { type: 'formChanged', values: PropertyFormValues }
| { type: 'locationChanged', location: { latitude: number, longitude: number } }
| { type: 'photoChanged', primaryPhotoId?: string | null }

const editPropertyReducer = (state: Property, action: Action): Property => {
  switch(action.type) {
    case 'propertyLoaded':
      return {...action.property}
    case 'formChanged':
      return updatePropertyFromFormValues(state, action.values)
    case 'locationChanged':
      return updateLocation(state, action.location)
    case 'photoChanged':
      return updatePrimaryPhoto(state, action.primaryPhotoId)
    default:
      return state
  }
}

export default editPropertyReducer